<template>
  <el-container>
    <el-header>
      <h3>申请演示</h3>
      <h5 v-if="applyForm.projectName">{{applyForm.projectName}}<a href="javascript:void(0)" @click="openDetailsUrl">产品介绍</a></h5>
    </el-header>
    <el-main class="el-main-apply">
      <el-form
        :model="applyForm"
        :rules="rulesForm"
        ref="applyForm"
        label-width="86px"
      >
        <!-- <el-form-item label="单位名称" prop="company" v-if="!sourceData.company">
          <el-input v-model="applyForm.company"></el-input>
        </el-form-item>
        <el-form-item label="单位名称" v-else >
          <el-input v-model="applyForm.company" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="单位名称" prop="company">
          <el-input v-model.trim="applyForm.company" ></el-input>
        </el-form-item>

        <!-- <el-form-item label="姓名" prop="name" v-if="!sourceData.name">
          <el-input v-model="applyForm.name"></el-input>
        </el-form-item>
        <el-form-item label="姓名" v-else >
          <el-input v-model="applyForm.name" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="姓名" prop="name">
          <el-input v-model.trim="applyForm.name"></el-input>
        </el-form-item>

        <!-- <el-form-item label="所在部门" prop="department" v-if="!sourceData.department">
          <el-input v-model="applyForm.department"></el-input>
        </el-form-item>
        <el-form-item label="所在部门" v-else >
          <el-input v-model="applyForm.department" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="所在部门" prop="department">
          <el-input v-model.trim="applyForm.department"></el-input>
        </el-form-item>

        <!-- <el-form-item label="职位名称" prop="position" v-if="!sourceData.position">
          <el-input v-model="applyForm.position"></el-input>
        </el-form-item>
        <el-form-item label="职位名称" v-else >
          <el-input v-model="applyForm.position" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="职位名称" prop="position">
          <el-input v-model.trim="applyForm.position"></el-input>
        </el-form-item>

        <!-- <el-form-item label="单位邮箱" prop="email" v-if="!sourceData.email">
          <el-input v-model="applyForm.email"></el-input>
        </el-form-item>
        <el-form-item label="单位邮箱" v-else >
          <el-input v-model="applyForm.email" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="单位邮箱" prop="email">
          <el-input v-model="applyForm.email"></el-input>
        </el-form-item>

        <!-- <el-form-item label="手机号码" prop="mobile" v-if="!sourceData.mobile">
          <el-input v-model="applyForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" v-else >
          <el-input v-model="applyForm.mobile" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="applyForm.mobile"></el-input>
        </el-form-item>

        <!-- <el-form-item label="办公电话" prop="tel" v-if="!sourceData.tel">
          <el-input v-model="applyForm.tel"></el-input>
        </el-form-item>
        <el-form-item label="办公电话" v-else >
          <el-input v-model="applyForm.tel" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item label="办公电话" prop="tel" >
          <el-input v-model="applyForm.tel"></el-input>
        </el-form-item>

        <!-- <el-form-item label="所在部门" prop="department">
          <el-input v-model="applyForm.department"></el-input>
        </el-form-item>
        <el-form-item label="职位名称" prop="position">
          <el-input v-model="applyForm.position"></el-input>
        </el-form-item>
        <el-form-item label="单位邮箱" prop="email">
          <el-input v-model="applyForm.email"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="applyForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="办公电话" prop="tel">
          <el-input v-model="applyForm.tel"></el-input>
        </el-form-item> -->
      </el-form>
    </el-main>
    <el-footer>
      <el-button :loading="loading" @click="submitFrom('applyForm')"
        >马上申请</el-button
      >
      <dl>
        <dd>信息提交后，我们会在1-2个工作日内联系您</dd>
        <dd>您也可以通过电话直接联系我们：021-64315006</dd>
      </dl>
    </el-footer>
  </el-container>
</template>

<script>
import { applyUse } from '@/api/display'
import { getUserInfo, getUserInfoNew } from '@/api/profile'
import {mapMutations, mapState} from 'vuex'
import Cookies from 'js-cookie';
export default {
  name: 'apply',
  data() {
    var validatePhone = (rule, value, callback) => {
      const reg = /^[1][3-9][0-9]{9}$/
      if (value == '' || value == undefined || value == null) {
        callback()
      } else {
        if (!reg.test(value) && value != '') {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      }
    }
    var validatePhoneTwo = (rule, value, callback) => {
      const reg = /^((0\d{2,3}-\d{7,8})|([1][3-9][0-9]{9}))$/
      if (value == '' || value == undefined || value == null) {
        callback()
      } else {
        if (!reg.test(value) && value != '') {
          callback(new Error('请输入正确的手机号码或者固话号码'))
        } else {
          callback()
        }
      }
    }
    var validateEMail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9\.]+\.[a-z]+$/
      if (value == '' || value == undefined || value == null) {
        callback()
      } else {
        if (!reg.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        } else {
          callback()
        }
      }
    }
    return {
      loading: false,
      // 源数据
      sourceData: {
        company: '',
        name: '',
        department: '',
        position: '',
        email: '',
        mobile: '',
        tel: '',
      },
      // 表单数据
      applyForm: {
        company: '',
        name: '',
        department: '',
        position: '',
        email: '',
        mobile: '',
        tel: '',
        account: this.$store.state.user.account,
        projectName: '',
        projectCode: '',
      },
      detailsUrl: Cookies.get('detailsUrl'),
      // 表单验证规则
      rulesForm: {
        company: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        department: [
          { required: true, message: '请输入所在部门', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请输入职位名称', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入单位邮箱', trigger: 'blur' },
          { validator: validateEMail, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入办公电话', trigger: 'blur' },
          { validator: validatePhoneTwo, trigger: 'blur' }
        ]
      }
    }
  },
  created(){
      this.getUserInfo();
  },
  computed: {
    ...mapState('display', {
      projectCode: 'projectCode'
    }),
  },
  // destroyed() {
  //   this.SET_PROJECTNAME('')
  //   this.SET_PROJECTCODE('')
  // },
  methods: {
    // ...mapMutations('display', {
    //   SET_PROJECTNAME: 'SET_PROJECTNAME',
    //   SET_PROJECTCODE: 'SET_PROJECTCODE'
    // }),
    // 获取用户信息
    async getUserInfo() {
			const { data } = await getUserInfoNew();
      // 赋值给源数据和表单对象
      this.assignObj(this.sourceData, data);
      this.assignObj(this.applyForm, data);

      // 防止被覆盖
      this.applyForm.projectName = Cookies.get('projectName');
      this.applyForm.projectCode = Cookies.get('projectCode');
      console.log(this.applyForm)
    },
    // 提交表单
    submitFrom(formName) {
      this.loading = true
      this.$refs[formName].validate(valid => {
        // 判断校验是否通过
        if (valid) {
          // 取出表单数据
          const { department, position, mobile, tel, company, name, email } = this[formName]
          let payload = {
            productCode:this.applyForm.projectCode,
            department,
            position,
            telephone:tel,
            mobile,
            unitName: company,
            userName: name,
            unitEmail: email
          }
          console.log(payload)

          // 提交申请请求
          applyUse(payload).then(
            res => {
              // 重置表单
              this.resetForm(formName)
              this.$message.success('申请成功, 即将跳转到产品展示页')
              this.loading = false
              setTimeout(() => {
                this.$router.push({ path: '/' });
              }, 3000)
            },
            err => {
              this.$message.error('申请失败')
              this.loading = false
            }
          )
        } else {
          // 校验未通过
          // this.$message.error('申请失败')
          this.loading = false
          return false
        }
      })
    },
    openDetailsUrl(){
      window.open(this.detailsUrl)
    },
    // 重置表单
    resetForm(formName) {
      // this.$refs[formName].resetFields()
    },
    assignObj(obj1, obj2) {
      for (const key in obj2) {
        if (obj1.hasOwnProperty(key)) {
          obj1[key] = obj2[key]
        }
      }
		}
  }
}
</script>

<style lang="scss">
.el-main-apply {
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before {
    content: '';
    margin-right: 0px;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label::after {
    content: '*';
    color: #ff4949;
    margin-left: 4px;
  }
  .el-form{
    .el-form-item{
      margin-bottom: 25px;
      .el-form-item__label{
        height: 42px;
        line-height: 42px;
      }
      .el-form-item__content{
        .text-left{
          text-align: left;
          padding: 0 8px 0 14px;
          height: 42px;
          line-height: 42px;
        }
        .el-form-item__error{
          color: #f56c6c;
          font-size: 12px;
          line-height: 1;
          padding-top: 4px;
          position: absolute;
          left: initial;
          top: -5px!important;
          right: 0px;
          transform: translateY(-100%);
        }
      }
    }
    @media only screen and (max-width: 1366px) {
      .el-form-item{
        margin-bottom: 25px;
        .el-form-item__label{
          height: 36px;
          line-height: 36px;
        }
        .el-form-item__content{
          .text-left{
            text-align: left;
            padding: 0 8px 0 14px;
            height: 36px;
            line-height: 36px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.el-container {
  padding-top: 15px;
  width: 580px;
  max-width: 580px;
  margin: auto;
  justify-content: center;
  .el-header {
    padding-left: 40px;
    padding: 0;
    height: auto!important;
    h3 {
      font-size: 20px;
      font-family: 'Source Han Sans SC';
      color: #434345;
      margin-bottom: 10px;
      height: 20px;
      line-height: 20px;
    }
    h5 {
      font-size: 16px;
      height: 16px;
      line-height: 16px;
      font-family: 'Source Han Sans SC';
      font-weight: 400;
      color: #434345;
      a{
        font-size: 16px;
        color: #514DEF;
        border-bottom: solid thin;
        margin-left: 4px;
      }
    }
  }
  .el-main-apply {
    width: 100%;
    padding: 0;
    flex: initial;
    margin: 36px auto 16px;
    padding: 20px 0;
    font-size: 14px;
    color: #343438;
  }
  .el-footer {
    padding: 0 0 0 27px;
    height: auto !important;
    color: #a4a4ad;
    .el-button {
      // width: 85%;
      width: 493px;
      margin: 0 auto;
      background: #514def;
      border-radius: 4px;
      font-size: 14px;
      font-family: 'Source Han Sans SC';
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 14px;
      height: 42px;
      border: none;
    }
    font-size: 14px;
    dl{
      height: 38px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      dd{
        height: 14px;
        line-height: 14px;
      }
    }
  }
}
@media only screen and (max-width: 1366px) {
  .el-container {
    padding-top: 15px;
    width: 580px;
    max-width: 580px;
    margin: auto;
    justify-content: center;
    .el-header {
      padding-left: 40px;
      padding: 0;
      height: auto!important;
      h3 {
        font-size: 20px;
        font-family: 'Source Han Sans SC';
        color: #434345;
        margin-bottom: 10px;
        height: 20px;
        line-height: 20px;
      }
      h5 {
        font-size: 16px;
        height: 16px;
        line-height: 16px;
        font-family: 'Source Han Sans SC';
        font-weight: 400;
        color: #434345;
        a{
          font-size: 16px;
          color: #514DEF;
          border-bottom: solid thin;
          margin-left: 4px;
        }
      }
    }
    .el-footer {
      padding: 0 0 0 27px;
      .el-button {
        margin-bottom: 14px;
        height: 36px;
      }
    }
    .el-main-apply {
      margin: 30px auto 10px;
      padding: 8px 0;
      font-size: 14px;
    }
  }
}
</style>
